import AlertDefinitionInfoPanel from 'thm/ui/common/alertDefinition/AlertDefinitionInfoPanel'
import ChildStache from 'thm/ui/common/alertDefinition/AlertDefinitionChargeLevelInfoPanelTpl.stache'

/**
 * @class AlertDefinitionChargeLevelInfoPanel
 * Alert Definition "Charge Level" Form.
 */
let AlertDefinitionChargeLevelInfoPanel = AlertDefinitionInfoPanel.extend({
  id: 'AlertDefinitionCloseToHerdInfoPanel',
  childTpl: ChildStache,
  //we made custom alertOnStart and alertOnEnd so let timingAllowed at false
  timingAllowed: false,

  /**
   * @override
   */
  initViewModel: function () {
    let me = this
    const optionsArray = [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80]
    me._super()
    me.viewModel.attr('chargeLevelOptions', optionsArray)
  },

  /**
   * @override
   */
  forceDefaultValues: function () {
    let me = this,
      dataModel = me.getDataModel()

    if (_.isUndefined(dataModel.min)) {
      me.viewModel.attr('dataModel.min', 70)
    }
    if (_.isUndefined(dataModel.alertOnStart)) {
      me.viewModel.attr('dataModel.alertOnStart', false)
    }
    if (_.isUndefined(dataModel.alertOnEnd)) {
      me.viewModel.attr('dataModel.alertOnEnd', false)
    }
  },
})
export default AlertDefinitionChargeLevelInfoPanel
